// export const timeRegex24h = /(0[0-9]|1[0-9]|2[0-3]):[0-5][0-9]/;
export const timeRegex24h = /([0-9]|0[0-9]|1?[0-9]|2[0-3]):[0-5]?[0-9]/gi;
export const TIME_FORMAT_24H = 'HH:mm';
